import { Component, EventEmitter, Injector, OnInit, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { GetAllProjectTimeSheetDto, OrganizationUnitDto, PagedResultDtoOfUserListDto, TeamDetailDto, UserListDto, UserServiceProxy } from '@shared/service-proxies/service-proxies';
import { AbpSessionService } from 'abp-ng2-module';
import { DateTime } from 'luxon';
import { LazyLoadEvent } from 'primeng/api';
import { Subject } from 'rxjs';
import { AppComponentBase } from '../../../../../shared/common/app-component-base';
import { TeamTrackingFilters } from '../../../activities/real-time-tracking/shared/top-stats-and-filters/top-stats-and-filters.component';
import { takeUntil } from "rxjs/operators";
import { Paginator } from 'primeng/paginator';
import { Table } from 'primeng/table';
import { SidePanelCheckService } from '../../../../shared/services/side-panel-check.service';
import { MonitoringService } from '@app/shared/common/telemetry-implementation/MonitoringService ';
import { AppRoutes } from '@app/shared/routes/app-routes';
@Component({
    standalone: false,
    selector: 'app-team-details-section',
    templateUrl: './team-details-section.component.html',
    styleUrls: ['./team-details-section.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TeamDetailsSectionComponent extends AppComponentBase implements OnInit {
    @ViewChild("paginator", { static: true })
    paginator: Paginator;
    @ViewChild("dataTable", { static: true })
    dataTable: Table;
    @Output()
    currentlySlackingTab: EventEmitter<number> = new EventEmitter<number>();
    protected ngUnsubscribe: Subject<void> = new Subject<void>();
    dateTime = new Date();
    msg: string;
    constructor(private _monitorService: MonitoringService, private _sessionService: AbpSessionService, _injector: Injector, private router: Router, private _userServiceProxy: UserServiceProxy, private designUitility: SidePanelCheckService) { super(_injector); }
    //Array for Team Details
    teamDetail: TeamDetailDto[];
    gridview = false;
    tableview = true;
    sortByNew: boolean = true;
    visible = true;
    isLoaded = false;
    isEmpty = true;
    filterString: any;
    selectedOrganizationItems: OrganizationUnitDto[] = [];
    selectedProjectItems: GetAllProjectTimeSheetDto[] = [];
    selectedMemberItems: UserListDto[] = [];
    selectedOrganizationIds: number[] = [];
    selectedProjectIds: number[] = [];
    selectedMemberIds: number[] = [];
    filterText: any;
    filterObj: TeamTrackingFilters = new TeamTrackingFilters();
    loading: boolean;
    InternetHover: boolean = false;
    rowHoverId: number = -1;
    selectedUser: UserListDto;
    istrueValue: boolean;
    ngOnInit(): void {
        this.msg = "userId = " + this._sessionService.userId + "tenantId =" + this._sessionService.tenantId;
        this._monitorService.logPageView("UI-TeamDetailsSection");
        this.getTenantId();
        this.getUserId();
        this.getTeamTrackingData();
    }
    /*
   *  On Organization Unit Filter
   */
    organizationUnitFilterChange(value) {
        this.selectedOrganizationItems = value;
        this.selectedOrganizationIds = [];
        this.selectedOrganizationItems.forEach(x => {
            this.selectedOrganizationIds.push(x.id);
        });
    }
    /*
    *  On Project Filter
    */
    projectFilterChange(value) {
        this.selectedProjectItems = value;
        this.selectedProjectIds = [];
        this.selectedProjectItems.forEach(x => {
            this.selectedProjectIds.push(x.id);
        });
    }
    /*
    *  On Member Filter
    */
    memberFilterChange(value) {
        this.selectedMemberItems = value;
        this.selectedMemberIds = [];
        this.selectedMemberItems.forEach(x => {
            this.selectedMemberIds.push(x.id);
        });
    }
    currentlySlackingDisplay() {
        this.currentlySlackingTab.emit(3);
    }
    getUserId() {
        return abp.session.userId;
    }
    getTenantId() {
        return abp.session.tenantId;
    }
    toggleShow() {
        this.tableview = true;
        this.gridview = false;
    }
    toggleShow_grid() {
        this.gridview = true;
        this.tableview = false;
    }
    getArrivalTime(date: DateTime) {
        if (!date)
            return '-';
        let jsDate = this.getLocalJsDate(date);
        let hours = jsDate.getHours() % 12;
        let min = jsDate.getMinutes();
        if (isNaN(hours) && isNaN(min)) {
            return '---';
        }
        else {
            return `${hours < 10 ? '0' + hours : hours}:${min < 10 ? '0' + min : min}`;
        }
    }
    getMeridian(date: DateTime) {
        if (!date)
            return '-';
        return date.hour <= 12 ? 'AM' : 'PM';
    }
    // get local js date from a UTC datetime object
    getLocalJsDate(date: DateTime): Date {
        if (!date)
            return;
        let jsDate = new Date(`${date.year}-${date.month < 10 ? '0' + date.month : date.month}-${date.day < 10 ? '0' + date.day : date.day}T${date.hour < 10 ? '0' + date.hour : date.hour}:${date.minute < 10 ? '0' + date.minute : date.minute}:00`);
        return new Date(jsDate.getTime() - jsDate.getTimezoneOffset() * 60 * 1000);
    }
    getHoursAndMin(timespan: string) {
        if (!timespan)
            return '00h 00m';
        let hours = parseInt(timespan.split(":")[0]);
        let min = parseInt(timespan.split(":")[1]);
        return `${hours < 10 ? "0" + hours : hours}:${min < 10 ? "0" + min : min} h`;
    }
    viewall() {
        this.router.navigate([AppRoutes.activitiesRealTimeTracking]);
    }
    viewCheck() {
        this.designUitility.userName.next('Display');
    }
    viewScreenshot(userid: number) {
        this.router.navigate([AppRoutes.activitiesScreenshots], { state: { userid: userid } });
    }
    //updated API call for the new teamtracking details
    getTeamTrackingData(event?: LazyLoadEvent) {
        try {
            this._monitorService.logTrace("UI-getTeamTrackingData", { "getTeamTrackingData ": "getRealTimeTracking Start: " + this + this.dateTime });
            this.loading = true;
            let currDate = new Date();
            this._userServiceProxy
                .getRealTimeTracking(this.filterObj.filterSearch, this.filterObj.memberFilterId, this.filterObj.projectFilterId, this.filterObj.organizationUnitFilterId, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, 5, this.primengTableHelper.getSkipCount(this.paginator, event), DateTime.fromJSDate(this.setZeroTimeForLocalDate(currDate)), currDate.getTimezoneOffset(), this.sortByNew, undefined)
                .pipe(takeUntil(this.ngUnsubscribe))
                .subscribe((result: PagedResultDtoOfUserListDto) => {
                this.primengTableHelper.totalRecordsCount = result.totalCount;
                this.primengTableHelper.records = result.items;
                this.loading = false;
                result.items.forEach(x => {
                    x.roleNames = x.roleNames.map(x => this.l(x));
                    if (!this.getCurrentlyUsingName(x) && x.currentlyUsing) {
                        x.applicationName = x.currentlyUsing;
                    }
                });
                this.markForCheck();
            });
        }
        catch (ex: any) {
            this._monitorService.logException(ex, 2);
        }
    }
    getCurrentlyUsingName(user: UserListDto): string {
        const name = user?.applicationName || user?.currentlyUsing;
        return name && name.trim() ? name.trim() : '';
    }

    hasCurrentlyUsingApp(user: UserListDto): boolean {
        return !!this.getCurrentlyUsingName(user);
    }

    setZeroTimeForLocalDate(date: Date): Date {
        date.setHours(0, 0, 0, 0);
        return new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
    }
    over(userIdOnHover: any) {
        this.rowHoverId = userIdOnHover;
        this.InternetHover = true;
    }
    out() {
        this.InternetHover = false;
        this.rowHoverId = -1;
    }
}
